// src/pages/BlogPage.jsx
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import "./BlogSection.css"; // ✅ Reuse same styles
import blog1 from "../assets/pm-1.jpg";
import blog2 from "../assets/pm-2.jpeg";
import blog3 from "../assets/pm-3.jpg";
import blog4 from "../assets/pm-4.jpg";
import blog5 from "../assets/pm-5.jpeg";
import blog6 from "../assets/pm-6.jpg";

// Sample Blog Data
const blogPosts = [
  {
    id: 1,
    image: blog1,
    category: "Finance",
    title: "How to choose the right colors when creating a coding website?",
    author: "Jenny Wilson",
    authorIcon: <FaUserCircle />,
    animation: { x: -80, y: 0 },
  },
  {
    id: 2,
    image: blog2,
    category: "Marketing",
    title: "How to choose the right photographer site for your portfolio?",
    author: "Jenny Wilson",
    authorIcon: <FaUserCircle />,
    animation: { x: 80, y: 0 },
  },
  {
    id: 3,
    image: blog3,
    category: "Business",
    title: "The Role of Business Ethics in Building Customer Trust & Loyalty",
    author: "Jenny Wilson",
    authorIcon: <FaUserCircle />,
    animation: { x: 0, y: 80 },
  },
  {
    id: 4,
    image: blog4,
    category: "Technology",
    title: "Top 10 Programming Languages to Learn in 2025",
    author: "Jenny Wilson",
    authorIcon: <FaUserCircle />,
    animation: { x: -80, y: 0 },
  },
  {
    id: 5,
    image: blog5,
    category: "Finance",
    title: "5 Best Practices for Managing Remote Teams Effectively",
    author: "Jenny Wilson",
    authorIcon: <FaUserCircle />,
    animation: { x: 80, y: 0 },
  },
  {
    id: 6,
    image: blog6,
    category: "Design",
    title: "UI/UX Design Principles That Make Websites Convert Better",
    author: "Jenny Wilson",
    authorIcon: <FaUserCircle />,
    animation: { x: 0, y: 80 },
  },
];

// Parent container for stagger animation
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

// Animation per card
const cardVariants = (animation) => ({
  hidden: { opacity: 0, ...animation },
  show: {
    opacity: 1,
    x: 0,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
});

const BlogPage = () => {
  return (
    <section className="blog-section py-5">
      <Container>
        <div className="text-center mb-5">
          <p className="section-subtitle">OUR BLOG</p>
          <h2 className="section-title2">
            Explore Our Latest <br /> News & Articles
          </h2>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
        >
          <Row>
            {blogPosts.map((post) => (
              <Col md={4} sm={6} xs={12} key={post.id} className="mb-4">
                <motion.div variants={cardVariants(post.animation)}>
                  <Card className="blog-card">
                    <Card.Img
                      variant="top"
                      src={post.image}
                      className="blog-img"
                    />
                    <Card.Body>
                      <span className="category">{post.category}</span>
                      <Card.Title className="blog-title">
                        {post.title}
                      </Card.Title>
                      <div className="author d-flex align-items-center mt-3">
                        <span className="author-icon">{post.authorIcon}</span>
                        <span className="author-name">By {post.author}</span>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  );
};

export default BlogPage;
